/* Vereinslogo im Browser auf höchstens 256 px an der längeren Seite verkleinern.
 *
 * Nur die Browser-Bausteine (Dekodieren, Canvas, Kodieren); was passiert und wann, steht in
 * domain/logoShrink.js (dort getestet). Dekodieren und die Zeichenfläche teilen sich den Code
 * mit useImageVariants.js (Spielerfotos). In Node nicht ausführbar.
 *
 * Transparenz: Die Zeichenfläche bleibt durchsichtig (keine Füllung), Ausgabe WebP oder PNG.
 * Bei starkem Verkleinern in zwei Schritten, wie bei den Fotos.
 */

import { decodeImage, newCanvas, toBlobAs } from './useImageVariants.js';
import { shrinkLogoWith } from '../domain/logoShrink.js';

const io = {
  decode: decodeImage,
  draw(decoded, width, height) {
    let from = decoded.source;
    let fw = decoded.width;
    let fh = decoded.height;
    if (fw > width * 2) {
      const mid = newCanvas(width * 2, Math.max(1, Math.round(height * 2)));
      mid.ctx.drawImage(from, 0, 0, fw, fh, 0, 0, mid.canvas.width, mid.canvas.height);
      from = mid.canvas;
      fw = mid.canvas.width;
      fh = mid.canvas.height;
    }
    const { canvas, ctx } = newCanvas(width, height);
    ctx.drawImage(from, 0, 0, fw, fh, 0, 0, width, height);
    return canvas;
  },
  toBlob: (canvas, type, quality) => toBlobAs(canvas)(type, quality),
  makeFile: (blob, name, type) => new File([blob], name, { type }),
};

/** Datei für den Upload vorbereiten: verkleinert oder (kleines PNG/WebP, SVG, nicht lesbar) unverändert. */
export function shrinkLogo(file) {
  return shrinkLogoWith(file, io);
}
